// Copyright (c) 2017 Deere & Company

import Wip from '../state/wip';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const readWip = (state, action) =>
    Wip.update(state, {
        $merge: {
            claims: action.data.claims,
            pips: action.data.pips,
            productTracking: action.data.productTracking,
            returnParts: action.data.returnParts
        }
    });

const readOpenPipSummary = (state, action) =>
    Wip.update(state, {
        $merge: {
            openPips: action.data
        }
    });

const updateTransferApprovalCount = (state, action) =>
    Wip.update(state, {
        productTracking: {
            $merge: {
                transferApprovals: action.data
            }
        }
    });

export default (state = getDefaultState().wip, action) => {

    const actionTypes = {
        [actions.GET_WIP]: readWip,
        [actions.GET_OPEN_PIP_SUMMARY]: readOpenPipSummary,
        [actions.GET_TRANSFER_APPROVAL_COUNT]: updateTransferApprovalCount
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/home-page/reducers/wip.js